import React from 'react';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useTranslatedMessages } from '../../../../hooks/useTranslatedMessages';

const VatTrendChart = ({ trend = [], loading = false }) => {
  const theme = useTheme();
  const { misDashboard: m } = useTranslatedMessages();

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, height: '100%' }}>
      <Typography variant="body2" fontWeight={500} sx={{ mb: 1 }}>
        {m.vat?.trend_title ?? 'Sales, Purchase & VAT Liability Trend'}
      </Typography>

      {loading ? (
        <Skeleton variant="rounded" height={320} />
      ) : !trend.length ? (
        <Box sx={{ height: 320, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            {m.vat?.no_data ?? 'No VAT data available for the selected filters.'}
          </Typography>
        </Box>
      ) : (
        <ResponsiveContainer width="100%" height={320}>
          <LineChart data={trend}>
            <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
            <XAxis dataKey="period" stroke={theme.palette.text.secondary} style={{ fontSize: 11 }} />
            <YAxis
              stroke={theme.palette.text.secondary}
              style={{ fontSize: 11 }}
              tickFormatter={(value) => `${Math.round(value / 1000)}k`}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 8,
                color: theme.palette.text.primary,
              }}
              formatter={(value) => `AED ${Number(value).toLocaleString()}`}
            />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line
              type="monotone"
              dataKey="sales"
              stroke={theme.palette.primary.main}
              strokeWidth={2.5}
              dot={{ r: 3 }}
              name={m.vat?.sales ?? 'Sales'}
            />
            <Line
              type="monotone"
              dataKey="purchases"
              stroke={theme.palette.success.main}
              strokeWidth={2.5}
              dot={{ r: 3 }}
              name={m.vat?.purchases ?? 'Purchase'}
            />
            <Line
              type="monotone"
              dataKey="vat_liability"
              stroke={theme.palette.error.main}
              strokeWidth={2.5}
              dot={{ r: 3 }}
              name={m.vat?.vat_liability ?? 'VAT Liability'}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default VatTrendChart;
